import React, { FC } from 'react';

import { YesNoQuestion } from '../YesNoQuestion';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';

export const Q38: FC<Record<string, unknown>> = () => (
  <YesNoQuestion question={BudgetQuestionCodes.Q38} />
);
